import { FC, forwardRef } from 'react';

import { ForwardProps } from '../../types';

import List, { ListProps } from './List';

const OrderedList: FC<ListProps & ForwardProps> = forwardRef(
  (props: ListProps, ref: ListProps['ref']) => <List {...props} variant='ordered' ref={ref} />
);

export default OrderedList;
